import { CommonModule, NgOptimizedImage } from '@angular/common';
import { BasePictureComponent } from '../base-picture/base-picture.component';
import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { Picture } from '../../../../../shared/public-api';

@Component({
  selector: 'admin-picture',
  templateUrl: './picture.component.html',
  styleUrls: ['./picture.component.scss'],
  imports: [CommonModule, NgOptimizedImage],
})
export class PictureComponent extends BasePictureComponent implements OnInit {
  baseUrl: string;
  fullScreenPicture: Picture;

  override ngOnInit(): void {
    this.baseUrl = environment.baseUrl;
    super.ngOnInit();
  }
}
